export const FETCH_TIME_IN_MILLISECOND = 3000;
export const PAGINATION_COUNT_STEP_THREE = 50;
export const PAGINATION_COUNT_STEP_SIX = 50;
export const PAGINATION_COUNT_STEP_SEVEN = 50;
export const INN_LIMIT = 12;
export const KPP_LIMIT = 11;
export const OGRN_LIMIT = 17;
